import React from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import moment from 'moment';
import Avatar from '@components/@core/Avatar';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';

const DepartmentHeader = () => (
    <Row className="mx-0 py-4 desktop-screen">
        <Col xs={4} className="d-h-start px-0">
            <p className="dsl-m12 mb-0">Department</p>
        </Col>
        <Col xs={1} className="d-h-center px-0" />
        <Col xs={1} className="d-h-center px-0">
            <p className="dsl-m12 mb-0">posts</p>
        </Col>
        <Col xs={1} className="d-h-center px-0">
            <Icon name="far fa-comment" size={12} />
        </Col>
        <Col xs={1} className="d-h-center px-0">
            <Icon name="far fa-eye" size={12} />
        </Col>
        <Col xs={4} className="d-h-start ps-4 pe-0">
            <p className="dsl-m12 mb-0">Latest post</p>
        </Col>
        <Col xs={1} className="px-0"></Col>
    </Row>
);

const DepartmentItem = ({ item, onClick }) => {
    const { name, data, latest } = item;
    return (
        <Row className="cursor-pointer mx-0 py-3" onClick={() => onClick && onClick(item)}>
            <Col xs={12} md={4} className="d-h-start px-0">
                <div className="department-logo me-2">
                    <Icon name={`fas fa-${data?.icon}`} size={16} />
                </div>
                <p className="dsl-b16 mb-0">{name}</p>
            </Col>
            <Col xs={12} md={1} className="d-h-start justify-content-sm-center px-0 ps-0 py-1 ssp-l-3">
                <p className="dsl-b16 mb-0 w-40">{data?.users?.length}</p>
            </Col>
            <Col xs={12} md={1} className="d-h-start justify-content-sm-center px-0 ps-0 py-1 ssp-l-3">
                <label className="dsl-b14 mobile-screen w-40 mb-0">Posts</label>
                <p className="dsl-b16 mb-0">{data?.stats?.blog_posts_abbr}</p>
            </Col>
            <Col xs={12} md={1} className="d-h-start justify-content-sm-center px-0 ps-0 py-1 ssp-l-3">
                <Icon name="far fa-comment dsl-b14 mobile-screen w-40 mb-0" size={12} />
                <p className="dsl-b16 mb-0">{data?.stats?.blog__comments_abbr}</p>
            </Col>
            <Col xs={12} md={1} className="d-h-start justify-content-sm-center px-0 ps-0 py-1 ssp-l-3">
                <Icon name="far fa-eye dsl-b14 mobile-screen w-40 mb-0" size={12} />
                <p className="dsl-b16 mb-0">{data?.stats?.blog__views_abbr}</p>
            </Col>
            <Col xs={12} md={4} className="d-h-start ps-4 ssp-l-3 pe-0 py-1">
                <label className="dsl-b14 mobile-screen w-40 mb-0">Latest Post</label>
                <p className="dsl-b14 truncate text-500 mb-0 mw-150">{latest[0]?.name}</p>
            </Col>
        </Row>
    );
};

const DepartmentDetailedItem = ({ post }) => {
    const { name, data, created_at } = post;
    return (
        <>
            <div className="d-h-between">
                <div className="d-h-start">
                    <Avatar type="logo" url={post.author_avatar} isSponsored={true} />
                    <div className="ml-2">
                        <p className="dsl-m14 mb-2">{`${post.author?.first_name} ${post.author?.last_name}`}</p>
                        <p className="dsl-m14 mb-0">{post.profile?.company}</p>
                    </div>
                </div>
                <p className="dsl-m14 mb-0">{moment(created_at).format('MMM DD, YY')}</p>
            </div>
            <p className="dsl-b18 bold my-3 truncate-two">{name}</p>
            <div className="post-body" dangerouslySetInnerHTML={{ __html: data?.body }} />
        </>
    );
};

export const DepartmentFeed = ({ department, posts, onChangePage }) => {
    if (!department) return null;

    const { name } = department;

    const handlePagination = (page) => {
        if (onChangePage) {
            onChangePage({ category_id: department.id, page });
        }
    };

    return (
        <div className="bg-white">
            <p className="dsl-b20 bold pt-3 ps-3 mb-0 mt-3">{name}</p>
            {posts?.data &&
                posts.data.map((item, index) => (
                    <div className="blog-category-section mb-3" key={`item-${index}`}>
                        <DepartmentDetailedItem post={item} />
                    </div>
                ))}
            {(!posts || posts?.total === 0) && <p className="dsl-b16 p-3">{`There are no ${name.toLowerCase()} posts.`}</p>}
            {posts?.last_page > 1 && <Pagination pers={[]} current={posts.current_page} perPage={posts.per_page} total={posts.last_page} onChange={handlePagination} />}
        </div>
    );
};

const Departments = ({ departments, onSelect }) => {
    const handleOpenDetail = (item) => {
        onSelect && onSelect(item);
    };
    return (
        <div className="blog-department-section mt-3">
            <p className="dsl-b20 bold my-2">Departments</p>
            {departments.length > 0 ? (
                <>
                    <DepartmentHeader />
                    {departments.map((department) => (
                        <DepartmentItem key={`department-${department.id}`} item={department} onClick={handleOpenDetail} />
                    ))}
                </>
            ) : (
                <p className="dsl-b16 p-3">There are no departments</p>
            )}
        </div>
    );
};

Departments.propTypes = {
    departments: PropTypes.array,
    onSelect: PropTypes.func,
};

Departments.defaultProps = {
    departments: [],
    onSelect: () => {},
};

export default Departments;
